export const DISEASE_AREAS = [
  "Oncology",
  "Breast Cancer",
  "Pain Management",
  "Osteoarthritis",
  "Chronic Kidney Disease",
  "Dry Eye Disease",
  "Neurological Conditions",
  "Sleep Disorders",
  "Mental Health",
  "Cancer-Related Anemia",
  "General Chronic Conditions",
  "General Measures",
  "Cancer-Specific Measures",
  "Cancer-Specific Symptom Indexes",
  "Treatment-Specific Measures",
  "Symptom-Specific Measures",
  "Financial Toxicity",
  "Disease-Specific Measures",
  "Pallative Care and Spiritual Well-Being",
  "Treatment Satisfaction",
  "Utility Indexes",
  "Pediatric Measures",
  "PROMIS Measures",
  "Additional Measures",
];

export const MAX_FILE_SIZE_5MB = 5 * 1024 * 1024;
